// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VdJtCkJnUk6gvZ {
  padding-left: 8px;
}
.QLgU7UN2H6tRMX {
  padding-top: 2px;
}
.QLgU7UN2H6tRMX span {
  width: 16px;
  height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"textPadding": `VdJtCkJnUk6gvZ`,
	"iconContainer": `QLgU7UN2H6tRMX`
};
export default ___CSS_LOADER_EXPORT___;
